import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import GroupsService from "services/GroupsService";

export const updateGroupSession = createAsyncThunk(
  "sessionTracking/updateGroupSession",
  async ({ sessionId, groupId, session }, { rejectWithValue }) => {
    try {
      await GroupsService.updateAdminSession(groupId, session);
      return { sessionId, session };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Erreur");
    }
  }
);

const initialState = {
  sessions: [],
  notifications: [],
  loading: false,
  error: null,
};

const sessionTrackingSlice = createSlice({
  name: "sessionTracking",
  initialState,
  reducers: {
    setInitialSessions: (state, { payload }) => {
      state.sessions = payload;
    },
    addSession: (state, { payload }) => {
      state.sessions = [...state.sessions, payload];
    },
    updateSession: (state, { payload }) => {
      const { id, changes } = payload;
      state.sessions = state.sessions.map((session) =>
        session.id === id ? { ...session, ...changes } : session
      );
    },
    addNotification: (state, { payload }) => {
      state.notifications = [...state.notifications, payload];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateGroupSession.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateGroupSession.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateGroupSession.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setInitialSessions,
  addSession,
  updateSession,
  addNotification,
} = sessionTrackingSlice.actions;

export default sessionTrackingSlice.reducer;
